import { SITE_CONFIG } from "@/config/site";
import { track } from "@/lib/analytics";

const productLinks = [
  { label: "O desejo", href: "#desejo" },
  { label: "Transformação", href: "#transformacao" },
  { label: "Produto", href: "#produto" },
  { label: "Ecossistema", href: "#recursos" },
  { label: "Para quem", href: "#para-quem" },
];

const businessLinks = [
  { label: "Teste grátis", href: "#teste-gratis" },
  { label: "Planos", href: "#planos" },
  { label: "Dúvidas frequentes", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

const legalLinks = [
  { label: "Privacidade", href: "#" },
  { label: "Termos", href: "#" },
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 pt-16 pb-8">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 border-b border-foreground-800/60 pb-12 md:grid-cols-2 lg:grid-cols-5">
          {/* Marca */}
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5" aria-label="PlayMenu">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-lg leading-none text-foreground-950" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold tracking-tight text-foreground-50">
                Play<span className="text-primary-500">Menu</span>
              </span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              O cardápio que desperta desejo.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href={SITE_CONFIG.instagramUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Instagram da PlayMenu"
                onClick={() => track("instagram_click", { location: "footer" })}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-foreground-700 text-foreground-300 transition-colors hover:border-primary-500 hover:text-primary-500"
              >
                <i className="ri-instagram-line text-lg" aria-hidden="true" />
              </a>
              <a
                href={SITE_CONFIG.siteUrl}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="text-sm text-foreground-400 transition-colors hover:text-foreground-100"
              >
                playmenu.app
              </a>
            </div>
          </div>

          {/* Produto */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500">
              Produto
            </h4>
            <ul className="mt-4 space-y-3">
              {productLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-500"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Negócios */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500">
              Negócios
            </h4>
            <ul className="mt-4 space-y-3">
              {businessLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-500"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-widest text-foreground-500">
              Legal
            </h4>
            <ul className="mt-4 space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-300 transition-colors hover:text-primary-500"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 pt-8 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © {year} PlayMenu. Todos os direitos reservados.
          </p>
          <p className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="flex h-4 w-4 items-center justify-center rounded-full bg-primary-500">
              <i className="ri-play-fill text-[10px] leading-none text-foreground-950" aria-hidden="true" />
            </span>
            {SITE_CONFIG.instagramHandle}
          </p>
        </div>
      </div>
    </footer>
  );
}